// ScrollTopButton.js
import React, { useState, useEffect } from "react";

const ScrollTopButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    show && (
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="btn btn-primary scroll-top-btn"
      >
        <i className="bi bi-arrow-up" style={{ fontSize: 20 }}></i>
      </button>
    )
  );
};

export default ScrollTopButton;
